import { groupBy } from "../omnia"
import { ActionPayload } from "./actions"
import { State } from "./state"
import { Parameters } from "./types"

type SetParametersState = Extract<State, { type: "setParameters" }>

export function startSetParameters(state: State): State {

    const { selection: { groups } } = state

    // Pick the largest group for initial values

    const group = [...groups].sort((a, b) => b.fields.length - a.fields.length)[0]

    const parameters = {
        ...(group?.parameters ?? { year: undefined, date: undefined, morganAnalysis: false }),
        fields: {}
    }

    return {
        ...state,
        type: "setParameters",
        parameters
    }

}


export function updateParameters(state: SetParametersState, { update }: ActionPayload<"updateParameters">) {

    const { parameters } = state

    state = {
        ...state,
        parameters: {
            ...parameters,
            ...update
        }
    }

    return state

}

export function groupByParameters<T extends Parameters>(items: T[]) {

    // Group items by parameters
    const groups = groupBy(items, i => i, getKey).map(g => {

        const { year, date, morganAnalysis, ...rest } = g.key

        const p: Parameters = {
            year,
            date,
            morganAnalysis
        }

        return {
            key: getKey(p),
            parameters: p,
            items: g.values
        }

    })

    // Sort by most descending date (year first, then date)
    const sorted = groups.sort((a, b) => (b.parameters.year - a.parameters.year) || (b.parameters.date?.localeCompare(a.parameters.date)))

    return sorted

}

export function getLabelForParameters(p: Parameters) {

    return [
        p.year,
        p.date ? new Date(p.date).toLocaleDateString() : "(no date set)",
        p.morganAnalysis ? "Morgan" : "Olsen"
    ].join(" - ")

}

function getKey(p: Parameters) {
    return [p.year, p.morganAnalysis, p.date].join("#")
}
